import { ImageOff } from 'lucide-react'
import React from 'react'
import { fighterEnties, fighterEntryDisplayMapping } from '../constants'
import { twMerge } from 'tailwind-merge';

export default function RankingCard({ fighter, index, entry, className }) {
    let totalWin = 0;
    let totalLoss = 0;
    let totalDraw = 0;

    fighterEnties.forEach((entry) => {
        totalWin += parseInt(fighter?.records?.[entry]?.win || 0);
        totalLoss += parseInt(fighter?.records?.[entry]?.loss || 0);
        totalDraw += parseInt(fighter?.records?.[entry]?.draw || 0);
    })

    return (
        <div className={twMerge(
            "min-w-[66vw] w-[66vw] md:min-w-[32vw] md:w-[32vw] lg:min-w-[24vw] lg:w-[24vw]",
            'border-2 flex-center items-start relative overflow-hidden',
            className,
            index === 0 ? "!bg-[#dedede] !text-black border-black" : ""
        )}>
            <div className={twMerge("absolute -top-1 -left-1 p-2 border-2 flex-center font-bold", index === 0 ? "!bg-[#dedede] !text-black border-black" : " bg-black")}>
                {String(index + 1).padStart(2, '0')}
            </div>
            {
                !!fighter?.fighterPicture
                    ? (
                        <img
                            src={fighter?.fighterPicture}
                            className={twMerge(
                                'aspect-square m-4 w-[calc(100%-2rem)] object-cover object-center',
                                index === 0
                                    ? "border-black border-4"
                                    : ""
                            )}
                            alt="Fighter_Image"
                        />
                    )
                    : <div className='w-full aspect-square flex-center'>
                        <ImageOff size={24} className='opacity-80' />
                    </div>
            }
            <p className='text-start self-start w-full font-bold text-xl uppercase truncate px-4'>
                {
                    fighter?.name ?? ""
                }
            </p>
            <p className='opacity-80 text-sm px-4'>
                {`${fighter?.height ?? "???"}cm · ${fighter?.age ?? 0} years old`}
            </p>
            <p className='opacity-80 text-sm px-4'>
                {`${!fighter?.gender
                    ? "?"
                    : fighter?.gender?.toUpperCase() === "M"
                        ? "Male"
                        : fighter?.gender?.toUpperCase() === "F"
                            ? "Female"
                            : "?"
                    } · ${fighter?.nationality ?? "???"}`}
            </p>
            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th className={twMerge('pt-0 text-center', index === 0 ? "text-black opacity-60" : "")}>W</th>
                        <th className={twMerge('pt-0 text-center', index === 0 ? "text-black opacity-60" : "")}>L</th>
                        <th className={twMerge('pt-0 text-center', index === 0 ? "text-black opacity-60" : "")}>D</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className={twMerge('border-y-2', index === 0 ? "border-black" : "border-[#dedede]")}>
                        <th className={twMerge('border-r-2 w-[calc(100%-3rem)]', index === 0 ? "border-black" : "border-[#dedede]")}>TOTAL</th>
                        <td className={twMerge('border-x-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{totalWin}</td>
                        <td className={twMerge('border-x-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{totalLoss}</td>
                        <td className={twMerge('border-l-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{totalDraw}</td>
                    </tr>
                    <tr className={twMerge('border-t-2', index === 0 ? "border-black" : "border-[#dedede]")}>
                        <th className={twMerge('border-r-2 w-[calc(100%-3rem)] text-nowrap', index === 0 ? "border-black" : "border-[#dedede]")}>{fighterEntryDisplayMapping[entry]?.toUpperCase()}</th>
                        <td className={twMerge('border-x-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{fighter?.records?.[entry ?? ""]?.win || 0}</td>
                        <td className={twMerge('border-x-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{fighter?.records?.[entry ?? ""]?.loss || 0}</td>
                        <td className={twMerge('border-l-2 text-center w-4 font-bold', index === 0 ? "border-black" : "border-[#dedede]")}>{fighter?.records?.[entry ?? ""]?.draw || 0}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}
